<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaUserForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaUserForm from '@/components/settings/arena/user/ArenaUserForm'

export default {
  name: 'ArenaUserAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaUserForm
  }
}
</script>
